// extracted by mini-css-extract-plugin
export var locationCard = "_g2-0";